import { writable } from 'svelte/store';
export function createCarouselStore() {
    const emblaApi = writable(null);
    const canScrollPrev = writable(false);
    const canScrollNext = writable(false);
    return { emblaApi, canScrollPrev, canScrollNext };
}
